export var ControllerConfigurationErrorCode;
(function (ControllerConfigurationErrorCode) {
    ControllerConfigurationErrorCode["CannotExportConfiguration"] = "CannotExportConfiguration";
})(ControllerConfigurationErrorCode || (ControllerConfigurationErrorCode = {}));
//# sourceMappingURL=IControllerConfigurationService.js.map